export default function sendDownloadSms(phoneNumber, pageUri = 'https://joinroot.onelink.me/mYM2/ec20797a') {
  const headersOptions = new Headers();
  headersOptions.append('Content-Type', 'application/x-www-form-urlencoded');

  const searchParams = new URLSearchParams();
  searchParams.append('pageUri', pageUri);
  searchParams.append('phoneNumber', `1${phoneNumber}`);

  return fetch('/api/sms', {
    headers: headersOptions,
    body: searchParams,
    method: 'POST',
  });
}
